module.exports = __webpack_public_path__ + "static/media/settings_room_device_brightness.9afddc91.svg";